import React from 'react';

export default {
    preplanningA: 'Please also email me a funeral planning guide PDF.',
    preplanningB: 'I’m interested in receiving info about pre-planning.'
};
